import React from 'react';
import Checkbox from '../Checkbox';
import styled from 'styled-components';

const VytalCheckboxLabelContainer = styled.div`
  display: inline-block;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  ${(props) =>
    props.readOnly
      ? `
    cursor: default; 
  `
      : ''}
`;

export const CheckboxLabel = styled.span`
  top: 0px;
  left: 30px;
  position: absolute;
  white-space: nowrap;
  ${(props) =>
    props.vytalStyle
      ? `
    color: white; 
  `
      : ''}
`;

function LabeledCheckBox({ checked, onClick, children, readOnly = false }) {
  return (
    <VytalCheckboxLabelContainer readOnly={readOnly}>
      <Checkbox
        checked={checked}
        vytalStyle
        onClick={readOnly ? null : onClick}
        readOnly={readOnly}
      />
      {/* @ts-ignore */}
      <CheckboxLabel onClick={readOnly ? null : onClick}>
        {children}
      </CheckboxLabel>
    </VytalCheckboxLabelContainer>
  );
}

export default LabeledCheckBox;
